"use client"

import { GiftIcon } from "@src/icons"
import { useEffect, useState } from "react"
import {
  getReferralDraft,
  onReferralStateChanged,
} from "../lib/referralStorage"

export function ReferredLoginNote() {
  const [hasReferral, setHasReferral] = useState(false)

  useEffect(() => {
    const check = () => setHasReferral(getReferralDraft() !== null)
    check()
    return onReferralStateChanged(check)
  }, [])

  if (!hasReferral) return null

  return (
    <section
      data-testid="referred-login-note"
      className="-outline-offset-1 mt-6 flex items-center gap-3 rounded-2xl bg-green-950 p-3 outline outline-transparent dark:outline-white/5"
    >
      <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-green-500/20">
        <GiftIcon className="size-4.5 text-green-400" />
      </div>
      <div className="flex-1 text-pretty text-sm/5">
        <h2 className="inline font-semibold text-white">
          A friend invited you to near.com.{" "}
        </h2>
        <p className="inline font-medium text-white/80">
          Join with their link and you'll both earn when you trade.
        </p>
      </div>
    </section>
  )
}
